  import {
      Card,
      Button,
      Badge,
      InfoSection,
      FormGroupInput,
      Checkbox
  }
  from '@/components';
  import {
      Select,
      Option
  }
  from 'element-ui'
import {
    AgGridVue
} from "ag-grid-vue";
  import AddEntityModal from '../components/modals/AddEntityModal.vue'
  import AddProceduresModal from '../components/modals/AddProceduresModal.vue'
  import itilityQueries from "@/graphql/itilityQueries";
  import { mapState } from 'vuex'
  export default {
      name: 'home',
      bodyClass: 'home',
      components: {
          Card,
          InfoSection,
          Badge,
          AgGridVue,
          AddEntityModal,
          AddProceduresModal,
          [Button.name]: Button,
          [Checkbox.name]: Checkbox,
          [FormGroupInput.name]: FormGroupInput,
          [Select.name]: Select,
          [Option.name]: Option,
      },
      data() {
          return {
              modals: ['procedures'],
              rowsSelected: false,
              series: [],
              module: this.$store.getters.get('module') || 'Clients'
          }
      },
      computed: {
          ...mapState({
              gql: 'gql', 
              slideWrapper: 'slideWrapper'
          }),
        rowData: function() {
        return this.series;
        },
        columnDefs: function() {
            if (this.series && this.series.length >0) {
                var columns = [
                {
                    headerName: 'ID',
                    field: 'id',
                    pinned: 'left',
                    sortable: true,
                    resizable: false,
                    rowDrag: false,
                    suppressSizeToFit: true,
                    headerClass: 'header-sample',
                    filter: true,
                    cellStyle: {
                        backgroundColor: '#f2f2f2',
                        textTransform: 'uppercase',
                        borderBottom: 'none',
                        textAlign: 'right',
                        paddingRight: '22px',
                        fontSize: '10px'
                    },
                    width: 80
                },
                ]
                var columns = [];
                var comp = Object.keys(this.series[0])
                var w = this;
                var index = false;
                comp.forEach(function(c, n) {
                    if ( c !== 'id' && c !== '__typename' ) {
                if ( (c === 'name' || c === 'number') && index === false  ) {
                index = true;
                var obj = 
                {
                    headerName: (c.charAt(0).toUpperCase() + c.slice(1)).replace(/_/g, ' '),
                    field: c,
                    pinned: 'left',
                    minWidth: c.length > 6 ? 120 : c.length > 10 ? 180 : 80,
                    sortable: true,
                    resizable: false,
                    rowDrag: false,
                    headerClass: 'header-sample',
                    filter: true,
                    cellStyle: {
                        backgroundColor: '#f2f2f2',
                        textTransform: 'uppercase',
                        borderBottom: 'none',
                        textAlign: 'left',
                        paddingRight: '22px',
                        fontSize: '10px'
                    },
                }
                } else {
                    var obj = {};
                    if ( c !== 'name' && c !== 'number' && c!== 'modifydate' && c!== 'createdate' ) {
                    obj.editable = true;
                    }
                    obj.sortable = true;
                    obj.headerName = (c.charAt(0).toUpperCase() + c.slice(1)).replace(/_/g, ' ');
                    if (c.endsWith('date')) {
                    obj.headerName = obj.headerName.replace(/date/, ' Date');
                    obj.valueFormatter = function(data) { return (new Date(data.value)).toLocaleString().split(',')[0] }
                    }
                    obj.field = c;
                    obj.resizable = true,
                    obj.filter = true,
                    obj.cellStyle = function() {
                        return {
                            textAlign: 'left'
                        }
                    };
                  }
                    columns.push(obj);
                }
                }) 
                return columns;
            } else {
                var columns = null;
                console.log(columns);
                return columns;
            }
        },
      },
      watch: {
          $route(to, from) {
              this.setModule()
              this.runQuery();
          }
      },
      beforeMount() {
        this.gridOptions = {
            suppressHorizontalScroll: true,
            animateRows: false,
            sortingOrder: [null],
            onFirstDataRendered: function(params) {},
            onModelUpdated: function(params) {
                setTimeout(function() {
                    params.api.sizeColumnsToFit();
                })
            },
            onGridReady: function(params) {
                window.addEventListener('resize', function() {
                    setTimeout(function() {
                        params.api.sizeColumnsToFit();
                    })
                })
            }
        }
      },
      mounted() {
          this.runQuery()
      },
      methods: {
        dateFormat(value) {
        return (new Date(value)).toLocaleDateString()
        },
        onSortChanged(event) {
            var columns = this.gridOptions.columnApi.getAllGridColumns()
            var sorted = columns.find(col => typeof(col.sort) !== 'undefined');
            if (sorted && sorted.colDef && sorted.colDef.field) this.processJSON(sorted.colDef.field, sorted.sort);
        },
        onDragStopped() {
            var headers = [];
            var columns = this.gridOptions.columnApi.getAllGridColumns()
            columns.forEach((col, i) => {
                if (col.colDef.field !== 'sample' && col.colDef.field !== 'distance') {
                    headers.push(col.colDef.field)
                }
            })
            this.$store.commit('change', {
                g25chartComponents: headers
            })
            this.components = headers;
            var series = this.series;
            var result = []
            headers.forEach(component => {
                result.push(series.find(item => item.name === component))
            })
            this.$store.commit('change', {
                g25chartSeries: result
            })
        },
        onSelectionChanged() {
            this.gridApi = this.gridOptions.api;
            var selectedRows = this.gridApi.getSelectedRows();
            if (selectedRows.length > 0) {
                this.rowsSelected = true;
            } else {
                this.rowsSelected = false;
            }
        },
          addEntity: function(event) {
              let entity = this.gql && this.modals.indexOf(this.gql) >= 0 ? `add${this.gql}` : 'addentity'
              this.$modal.show(entity, {
                  action: 'add',
                  index: {module: this.module}
              });
          },
          setModule: function() {
              let module = (this.$store.getters.get('module'))
              this.module = module;
          },
          runQuery: function() {
            this.$store.commit('change', { slideWrapper: 'hidden' })
              let gql = (this.$store.getters.get('gql'))
              if (gql) {
              var query = itilityQueries[gql].list
              this.$apollo.query({
                  query: query,
                  fetchPolicy: 'network-only'
              }).then(data => {
                  if (data.data) {
                      if (Object.keys(data.data).length > 0) {
                          let q = Object.keys(data.data)[0]
                          this.series = data.data[q].items;
            this.$store.commit('change', { slideWrapper: 'visible' })
                      }
                  }
              }).
              catch(err => {
                  console.log(err)
                  this.series = []
            this.$store.commit('change', { slideWrapper: 'visible' })
              })
              } else {
                  setTimeout( () => {
                  this.series = []
            this.$store.commit('change', { slideWrapper: 'visible' })
                  }, 200)
              }
          }
      }
  }
